/**
 * Runtime configuration for the application.
 *
 * Reads environment-specific values from `window.__APP_CONFIG__`, which is set
 * by `/config.js` (a static file copied from `public/`). In deployed
 * environments the deploy pipeline overwrites `config.js` with the values for
 * that environment before uploading to Azure Static Web Apps, so the same
 * build artifact can be deployed to test, staging and production.
 *
 * Falls back to `import.meta.env` (VITE_*) for local development.
 */
const runtime = globalThis.__APP_CONFIG__ || {}

export const runtimeConfig = {
  appEnv: runtime.appEnv || import.meta.env.VITE_APP_ENV || 'development',
  apiUrl: runtime.apiUrl || import.meta.env.VITE_API_URL || '',
  apiPort: runtime.apiPort || import.meta.env.VITE_API_PORT || '',
  apiVersion: runtime.apiVersion || import.meta.env.VITE_API_VERSION || '',
  apiId: runtime.apiId || import.meta.env.VITE_API_ID || '',
  apiTimeout: Number(runtime.apiTimeout ?? import.meta.env.VITE_API_TIMEOUT ?? 0),
  signalrUrl: runtime.signalrUrl || import.meta.env.VITE_SIGNALR_URL || '',
  sentryDsn: runtime.sentryDsn || import.meta.env.VITE_SENTRY_DSN || '',
  sentryTracesPropagationTargets:
    runtime.sentryTracesPropagationTargets ||
    import.meta.env.VITE_SENTRY_TRACES_PROPAGATION_TARGETS ||
    'localhost',
  sentryTracesSampleRate: Number(
    runtime.sentryTracesSampleRate ?? import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? 0,
  ),
  sentryReplaysSessionSampleRate: Number(
    runtime.sentryReplaysSessionSampleRate ??
      import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE ??
      0,
  ),
  sentryReplaysOnErrorSampleRate: Number(
    runtime.sentryReplaysOnErrorSampleRate ??
      import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE ??
      0,
  ),
  clarityProjectId: runtime.clarityProjectId || import.meta.env.VITE_CLARITY_PROJECT_ID || '',
}
